var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgJs(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_647_16)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_647_16",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 64,
    height: 64
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H64V64H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_647_16)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H64V64H0V0ZM48.9253 53.6533C45.9573 53.6533 44.28 52.1067 42.992 50L38.104 52.84C39.8693 56.328 43.4773 58.9893 49.064 58.9893C54.776 58.9893 59.0293 56.024 59.0293 50.608C59.0293 45.5867 56.144 43.3547 51.0347 41.16L49.5307 40.5173C46.9493 39.3973 45.832 38.6693 45.832 36.864C45.832 35.4053 46.952 34.288 48.712 34.288C50.4373 34.288 51.5493 35.016 52.5813 36.864L57.264 33.8587C55.2827 30.3733 52.536 29.0427 48.712 29.0427C43.3413 29.0427 39.904 32.4773 39.904 36.9893C39.904 41.8827 42.784 44.2 47.1253 46.048L48.6293 46.6933C51.3733 47.8933 53.008 48.624 53.008 50.6853C53.008 52.408 51.416 53.6533 48.9253 53.6533ZM25.6187 53.6133C23.552 53.6133 22.6907 52.2 21.7467 50.52L16.8507 53.4853C18.2693 56.488 21.0587 58.9787 25.872 58.9787C31.2027 58.9787 34.8533 56.144 34.8533 49.9173V29.384H28.84V49.8373C28.84 52.8427 27.592 53.6133 25.616 53.6133H25.6187Z",
    fill: "#5C5B5B"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_647_16"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJs);
export default __webpack_public_path__ + "static/media/js.ed337dac84ee0d8258e3860df0c9a153.svg";
export { ForwardRef as ReactComponent };